import axios from "../api";
export const getUserRecommendations = async () => {
    const res = await axios.get("/user-squads/active/player-recommendations");
    return res.data;
};
export const markRecommendationsAsViewed = () => axios.post("/user-squads/active/player-recommendations/mark-as-viewed");
/** Works out new recommendations for the active squad. Metered. */
export const computeNewPlayerRecs = async () => {
    const res = await axios.post("/user-squads/active/player-recommendations?v=2");
    return res.data;
};
/** The gain an upgrade brings on one axis; 0 when it brings none. */
export const upgradeDelta = (rec, type) => rec.individualUpgrades.find((u) => u.type === type)?.upgradeDelta ?? 0;
//# sourceMappingURL=recommendations.js.map